<div *ngIf="dataSource.filteredData.length" class="flex flex-col">
  <table
    mat-table
    matSort
    class="flex-1"
    matSortActive="plan.createdAt"
    matSortDirection="desc"
    [dataSource]="dataSource"
  >
    <ng-container matColumnDef="plan.status">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Status</th>
      <td *matCellDef="let data" mat-cell>
        <pr-treatment-plan-status
          class="w-20"
          dense
          [status]="data.plan.status"
        />
      </td>
    </ng-container>

    <ng-container matColumnDef="patient.name">
      <th *matHeaderCellDef mat-header-cell>Patient</th>
      <td *matCellDef="let data" mat-cell>
        <a [prBrandRouterLink]="['patients', data.patient.ref.id]">
          {{ data.patient.name }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="plan.name">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Name</th>
      <td *matCellDef="let data" mat-cell>
        <a
          [prBrandRouterLink]="[
            'patients',
            data.patient.ref.id,
            'treatment-plans',
            data.plan.ref.id
          ]"
        >
          {{ data.plan.name }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="plan.createdAt">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Created</th>
      <td *matCellDef="let data" mat-cell>
        {{ data.plan.createdAt | moment | amDateFormat: dateFormat }}
      </td>
    </ng-container>

    <ng-container matColumnDef="price">
      <th *matHeaderCellDef mat-header-cell class="right-align !px-4">Price</th>
      <td *matCellDef="let data" mat-cell class="right-align">
        {{ data | map: price$ | ngrxPush | currency }}
      </td>
    </ng-container>

    <ng-container matColumnDef="progress">
      <th *matHeaderCellDef mat-header-cell class="right-align !px-4">
        Progress
      </th>
      <td *matCellDef="let data" mat-cell class="right-align">
        {{ data | map: progress$ | ngrxPush | percent }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th *matHeaderCellDef mat-header-cell class="right-align !px-4">
        Actions
      </th>
      <td *matCellDef="let data" mat-cell>
        <div class="flex items-center justify-end gap-2">
          <button
            *ngIf="data | map: canBeAccepted"
            mat-stroked-button
            color="primary"
            aria-label="Accept"
            matTooltip="Accept Treatment Plan"
            (click)="acceptPlan(data)"
          >
            Accept
          </button>
          <button
            *ngIf="data | map: canBeDeclined"
            mat-stroked-button
            color="warn"
            aria-label="Decline"
            matTooltip="Decline Treatment Plan"
            (click)="declinePlan(data)"
          >
            Decline
          </button>
          <button
            *ngIf="data | map: canBeCompleted$ | ngrxPush"
            mat-stroked-button
            color="accent"
            aria-label="Complete"
            matTooltip="Complete Treatment Plan"
            (click)="completePlan(data)"
          >
            Complete
          </button>
          <ng-container *ngIf="data | map: isComplete">
            <button mat-icon-button [matMenuTriggerFor]="moreMenu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #moreMenu="matMenu">
              <button mat-menu-item (click)="reactivatePlan(data)">
                <mat-icon>restart_alt</mat-icon>
                <span>Reactivate Plan</span>
              </button>
            </mat-menu>
          </ng-container>
        </div>
      </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
  </table>
</div>
